import * as React from 'react';

import { Tooltip } from '@cotera/client/app/components/ui/tooltip';
import { Button } from '@cotera/client/v0/components/ui/button';
import { cn } from '@cotera/client/v0/lib/utils';
import { Icon } from '../../../../ui/icon/icon';
import { useCommentsRail } from './comments-rail-provider';

/**
 * The header's way into the comments index, beside Share.
 *
 * Renders nothing when no editor has offered itself as a target — an empty chat, or
 * an artifact that is not a document — rather than a button that opens an empty
 * column.
 *
 * Carries no count. The document already says how many comments it has and where they
 * are: cards down the margin where there is room for them, a count per line where
 * there is not. A running total up here would be a second, worse answer to a question
 * already answered in the place it matters. What is left is the one thing the header
 * is for — a way in that does not depend on having scrolled to a comment first.
 */
export const CommentsRailToggle: React.FC<{ className?: string }> = ({
  className,
}) => {
  const rail = useCommentsRail();

  if (rail === null || rail.target === null) {
    return null;
  }

  const label = rail.open ? 'Hide comments' : 'Show comments';

  return (
    <Tooltip side="bottom" tooltipContent={label}>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={cn('size-8 shrink-0 p-0', className)}
        aria-label={label}
        aria-pressed={rail.open}
        onClick={rail.toggle}
      >
        <Icon icon="message-square-more" />
      </Button>
    </Tooltip>
  );
};
